import Btn from "@/components/Btn";
import { IChangePassword } from "@/interfaces/auth.interface";
import authService from "@/services/auth.service";
import { useAppDispatch } from "@/store/hooks/hooks";
import ToastService from "@/utils/toast";
import { Field, FieldWrapper, Form, FormElement, FormRenderProps } from "@progress/kendo-react-form";
import { Input } from "@progress/kendo-react-inputs";
import { ChevronLeft } from "lucide-react";
import React from "react";
import { Link, useNavigate } from "react-router-dom";

const ChangePasswordForm: React.FC = () => {
  const [resetPasswordValues] = React.useState<IChangePassword>({
    oldPassword: "",
    password: "",
    confirmPassword: "",
  });

  const navigateTo = useNavigate();

  const handleSubmit = (dataItem: { [name: string]: IChangePassword }) => {
    if (dataItem.password === dataItem.confirmPassword) {
      authService
        //@ts-ignore
        .changePassword(dataItem.oldPassword, dataItem.password)
        .then((response: any) => {
          if (!response.error) {
            ToastService.success("Password changed successfully");
            navigateTo("/");
          } else {
            ToastService.error(response.error);
          }
        })
        .catch((error: any) => {
          console.error(error);
        });
    } else {
      ToastService.error("Passwords are not matching");
    }
  };

  return (
    <div className="w-full">
      <div className="mb-4">
        <Link to="/">
          <button className="p-0 text-[#A3AED0]">
            <span className="inline-flex items-center">
              <ChevronLeft className="w-4 h-4 text-[#A3AED0]" />{" "}
              <span className="ml-1 text-[#A3AED0] font-cabin font-medium">Go Back</span>
            </span>
          </button>
        </Link>
      </div>

      <h3 className="text-[27px] cabin-500 text-[#2B3674] font-bold">Create New Password</h3>
      <p className="text-[#A3AED0] text-[12px]">You are one step away!</p>
      <div className="mt-5">
        <Form
          initialValues={resetPasswordValues}
          onSubmit={handleSubmit}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement className="mb-4">
              <fieldset className={"k-form-fieldset"}>
                <FieldWrapper>
                  <div className="k-form-field-wrap">
                    <div className="relative loginField">
                      <Field
                        name={"oldPassword"}
                        type={"password"}
                        component={Input}
                        label={"Old Password"}
                        placeholder={"Old Password"}
                        labelClassName="font-cabin font-medium mb-2 text-[var(--kendo-neutral-160)]"
                      />
                    </div>
                  </div>
                </FieldWrapper>

                <FieldWrapper>
                  <div className="k-form-field-wrap">
                    <div className="relative loginField">
                      <Field
                        name={"password"}
                        type={"password"}
                        component={Input}
                        label={"New Password"}
                        placeholder={"New Password"}
                        labelClassName="font-cabin font-medium mb-2 text-[var(--kendo-neutral-160)]"
                      />
                    </div>
                  </div>
                </FieldWrapper>

                <FieldWrapper className="mb-4">
                  <div className="k-form-field-wrap">
                    <div className="relative loginField">
                      <Field
                        name={"confirmPassword"}
                        type={"password"}
                        component={Input}
                        label={"Confirm Password"}
                        placeholder={"Confirm Password"}
                        labelClassName="font-cabin font-medium mb-2 text-[var(--kendo-neutral-160)]"
                      />
                    </div>
                  </div>
                </FieldWrapper>
              </fieldset>

              <div className="k-form-buttons">
                <Btn
                  variant="primary"
                  text={"Update Password"}
                  disabled={!formRenderProps.allowSubmit}
                  onClick={() => {}}
                />
              </div>
            </FormElement>
          )}
        />
      </div>
    </div>
  );
};

export default ChangePasswordForm;
